<template>
  <tr class="table-row">
    <!-- Each Cell -->
    <template v-for="column in grid.headers">
      <td
        :key="`${row[rowId]}-${row[rowKey]}-${column.key}`"
        :class="[column.key, column.cssClasses]"
        class="b2b-grid__cell lg:table-cell"
      >
        <div class="b2b-grid__label" v-html="column.label"></div>

        <div class="b2b-grid__content" :qaid="`shipmentsInquiry.${column.key}-${rowId}`">
          <template v-if="column.key === 'hangTag'">
            <icon
              name="local_offer"
              class="cursor-pointer md:ml-2"
              :qaid="`shipmentsInquiry.downloadHangTags-${rowId}`"
              @click.native="downloadHangTags"
            />
          </template>
          <template v-else-if="column.key === 'packingSlipNumber'">
            <div class="flex justify-start items-end">
              <span v-html="row[column.key]" />
              <icon
                name="get_app"
                class="cursor-pointer ml-1 text-secondary"
                :qaid="`shipmentsInquiry.downloadPackingSlip-${rowId}`"
                @click.native="downloadPackingSlip"
              />
            </div>
          </template>
          <template v-else-if="column.key === 'shipmentTrackingNumber'">
            <div class="flex justify-start items-end">
              <span v-html="row[column.key]" />
              <icon
                v-if="row.shipmentTrackingUrl"
                name="launch"
                class="cursor-pointer ml-1 text-secondary"
                :qaid="`shipmentsInquiry.openTrackingLink-${rowId}`"
                @click.native="openTrackingLink"
              />
            </div>
          </template>
          <!-- All other cells -->
          <span v-else v-html="row[column.key]" />
        </div>
      </td>
    </template>
  </tr>
</template>

<script>
import {mapState} from 'vuex';
import Icon from '@/components/Icon';

export default {
  inject: ['grid'],
  components: {Icon},
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    row: {
      type: [Object, Array],
      default: () => [],
    },
    rowId: {
      type: [String, Number],
      default: '',
    },
    rowKey: {
      type: String,
      default: 'id',
    },
  },

  computed: {
    ...mapState('backend', ['encodedContextPath']),
  },

  methods: {
    downloadHangTags() {
      window.open(`${this.encodedContextPath}/hang-tags/${this.row.packingSlipNumber}?shipments=true`, '_blank');
    },

    downloadPackingSlip() {
      window.open(
        `${this.encodedContextPath}/my-account/packingslip-data/${this.row.packingSlipNumber}/pdf/?&pdfView=true&tidyHTML=true`,
        '_blank'
      );
    },

    openTrackingLink() {
      window.open(this.row.shipmentTrackingUrl, '_blank');
    },
  },
};
</script>
